<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="true"
      :show-close="true" :close-on-press-escape="true" v-dialogDrag>
      <span slot='title' class="el-dialog__title">详情</span>
      <!-- <el-input class="mhSearch" placeholder="请输入内容" v-model="input" clearable @input="searchInput"></el-input> -->
      <el-table :data="tableData" :row-class-name="rowIndex" stripe style="width: 100%;" height="500" empty-text="无数据"
        @row-dblclick="dbClick">
        <el-table-column :formatter="order" label="序号" width="60"></el-table-column>
        <el-table-column prop="ydbSheng" label="省" width="80"></el-table-column>
        <el-table-column prop="ydbShi" label="市" width="80"></el-table-column>
        <el-table-column prop="ydbXian" label="县" width="80"></el-table-column>
        <el-table-column prop="ydbxiang" label="乡" width="100"></el-table-column>
        <el-table-column prop="ydbcun" label="村" width="100"></el-table-column>
        <el-table-column prop="ydbName" label="坝名" width="120"></el-table-column>
        <el-table-column prop="ydbXzzrr" label="行政责任人姓名" width="140"></el-table-column>
        <el-table-column prop="ydbXzzrrzw" label="行政责任人职务" width="140"></el-table-column>
        <el-table-column prop="ydbXzzrrlxfs" label="行政责任人联系方式" width="170"></el-table-column>
        <el-table-column prop="ydbJszrr" label="技术责任人姓名" width="140"></el-table-column>
        <el-table-column prop="ydbJszrrzw" label="技术责任人职务" width="140"></el-table-column>
        <el-table-column prop="ydbJszrrlxfs" label="技术责任人联系方式" width="170"></el-table-column>
        <el-table-column prop="ydbXczrr" label="巡查责任人姓名" width="140"></el-table-column>
        <el-table-column prop="ydbXczrrzw" label="巡查责任人职务" width="140"></el-table-column>
        <el-table-column prop="ydbXczrrlxfs" label="巡查责任人联系方式" width="170"></el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
  import {
    ydbjbxxsearch,
    selectYdbInfoForYdbCodesX
  } from "@/api/api.js";
  export default {
    props: ["jichuanData"],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "60%",
        currentPage: 1,
        pageSize: 15,
        tableData: [],
        totalNum: 0,
        input: '',

        // 检索信息
        bxlj: '',
        sfyr: '',
        JYDJ: '',
        bx: '',
        zyss: '',
        ly: '',
      }
    },
    mounted() {
      if (this.jichuanData[0].bxlj) {
        this.bxlj = this.jichuanData[0].bxlj;
      }
      if (this.jichuanData[0].sfyr) {
        this.sfyr = this.jichuanData[0].sfyr;
      }
      if (this.jichuanData[0].JYDJ) {
        this.JYDJ = this.jichuanData[0].JYDJ;
      }
      if (this.jichuanData[0].bx) {
        this.bx = this.jichuanData[0].bx;
      }
      if (this.jichuanData[0].zyss) {
        this.zyss = this.jichuanData[0].zyss;
      }
      if (this.jichuanData[0].ly) {
        this.ly = this.jichuanData[0].ly;
      }
      let params = {
        regionCode: this.jichuanData[0].regionCode,
        yuShi: this.$store.state.yuShi,
        bxlj: this.bxlj,
        sfyr: this.sfyr,
        JYDJ: this.JYDJ,
        bx: this.bx,
        zyss: this.zyss,
        ly: this.ly,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      this.selectYdbInfoForYdbCodesXFun(params);
    },
    methods: {
      tixingC() {
        this.$message({
          message: '已通过app与短信发送提醒！',
          type: 'success'
        });
      },

      dbClick(row) {
        let params = {
          ydbCode: row.ydbCode,
          yuShi: this.$store.state.yuShi
        };
        ydbjbxxsearch(params).then((res) => {
          this.$emit("queryDatas", res.data);
          this.$store.commit('queryData', res.data); //token
          this.cancel();
        });
      },

      selectYdbInfoForYdbCodesXFun(params) {
        selectYdbInfoForYdbCodesX(params).then((res) => {
          // console.log('===================>', res)
          this.totalNum = res.total;
          this.tableData = res.data;
        });
      },

      searchInput(value) {
        let params;
        if (value != '') {
          params = {
            ydbName: value,
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesXFun(params);
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        let params;
        if (this.input != '') {
          params = {
            ydbName: this.input,
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesXFun(params);
      },

      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;

        let params;
        if (this.input != '') {
          params = {
            ydbName: this.input,
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        } else {
          params = {
            regionCode: this.jichuanData[0].regionCode,
            yuShi: this.$store.state.yuShi,
            bxlj: this.bxlj,
            sfyr: this.sfyr,
            JYDJ: this.JYDJ,
            bx: this.bx,
            zyss: this.zyss,
            ly: this.ly,
            pageNum: this.currentPage,
            pageSize: this.pageSize
          };
        }
        this.selectYdbInfoForYdbCodesXFun(params);
      },

      rowIndex({
        row,
        rowIndex
      }) {
        row.rowIndex = rowIndex;
      },

      order(row) {
        return this.pageSize * (this.currentPage - 1) + row.rowIndex + 1;
      }
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 600px;
    margin-top: 30vh !important;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 510px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }
  
  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }

  .mhSearch {
    position: absolute;
    top: 0;
    right: 80px;
    width: 200px;
    margin-top: 8px;
    /* transform: translate(-50%); */
  }

  .tixing {
    position: absolute;
    top: 9px;
    left: 7%;
    padding: 5px;
  }

  >>>.el-input__inner {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__suffix {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-input__icon {
    height: 25px;
    line-height: 25px;
  }

  >>>.el-table {
    margin-top: 10px;
    border-color: #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table thead {
    background-color: rgba(0, 179, 254, 0.5) !important;
  }

  >>>.el-table .cell {
    text-align: center;
    font-size: 16px;
    color: #eaeaea;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: rgba(0, 179, 254, 0.3) !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }

  >>>.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: rgba(0, 179, 254, 0.1);
  }

  >>>.el-pagination {
    margin-top: 4px;
    text-align: center;
    color: #fff;
  }

  >>>.el-pagination__total {
    color: #fff;
  }

  >>>.el-pagination__jump {
    color: #fff;
  }

  >>>.el-input__inner {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li {
    background: transparent;
    border: 0.5px solid #fff;
    padding: 0;
    margin: 0 4px;
  }

  >>>.el-pager li.btn-quicknext,
  .el-pager li.btn-quickprev {
    color: #fff;
  }

  >>>.el-pager .more::before {
    color: #fff;
  }

  >>>.el-pagination .btn-prev {
    background: transparent;
    color: #fff;
  }

  >>>.el-pagination .btn-next {
    background: transparent;
    color: #fff;
  }

  >>>.el-pager li.active+li {
    border-left: 1px solid #fff !important;
  }
</style>
